import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { PATIENT_PROFILE_QUERY_KEY, REGISTER_CONTACT_ATTEMPT_MUTATION_KEY } from '../constants';
import { registerContactAttempt } from '../services';
import { RegisterContactAttemptProps } from '../types';

function useMutationRegisterContactAttempt(
  onSuccess: () => void,
  onError?: (err: any) => any,
): UseMutationResult<string, unknown> {
  const queryClient = useQueryClient();

  const mutationFn = async (props: RegisterContactAttemptProps): Promise<any> => {
    return await registerContactAttempt(props);
  };

  const onMutateFn = async (): Promise<any> => {};

  const onErrorFn = (err: unknown): void => {
    onError?.(err);
  };

  const onSettledFn = async (): Promise<void> => {};

  const onSuccessFn = async (): Promise<void> => {
    void queryClient.invalidateQueries([PATIENT_PROFILE_QUERY_KEY]);
    onSuccess?.();
  };

  return useMutation<string, unknown, any, any>([REGISTER_CONTACT_ATTEMPT_MUTATION_KEY], mutationFn, {
    onMutate: onMutateFn,
    // If the mutation fails, use the context returned from onMutate to roll back
    onError: onErrorFn,
    // Always refetch after error or success:
    onSettled: onSettledFn,
    onSuccess: onSuccessFn,
  });
}

export default useMutationRegisterContactAttempt;
